import { EvaluateStock, EvaluateStockBody } from "../models/types";
import { httpPostAuthenticated } from "./Api";

const endpoints = {
  evaluate: () => "/stocks/evaluate_stock",
};

export const evaluateStock = async (body: EvaluateStockBody) => {
  return httpPostAuthenticated<EvaluateStock>(endpoints.evaluate(), body);
}